import React from 'react';

const AlgorithmSelector = ({ onChange }) => {
  const algorithms = [
    'SPTNet (PyTorch)',
    'DeepTrack (TensorFlow)',
    'TrackMate (Java Plugin)',
    'uTrack (MATLAB)',
    'BNP-Track (MATLAB + Bayesian)',
    'DeepTrack (Non-ML Baseline)'
  ];

  return (
    <div className="mb-4">
      {/* <label className="block mb-2 font-medium text-gray-700">Select Algorithm</label> */}
      <label className="block mb-2 font-semibold text-gray-700">
        🧠 Select an Algorithm to Run
      </label>

      <select
        onChange={(e) => onChange(e.target.value)}
        className="border border-gray-300 rounded px-4 py-2 w-full"
      >
        <option value="">-- Select an algorithm --</option>
        {algorithms.map((alg, index) => (
          <option key={index} value={alg}>
            {alg}
          </option>
        ))}
      </select>
    </div>
  );
};

export default AlgorithmSelector;
